import Task from "../../../../lib/html5-software-library/src/ranj/util/executor/Task";
import AssetLoadServiceEvent from "../../app/assetloading/AssetLoadServiceEvent";

export default class LoadPreloadAssetsTask extends Task {
    /**
     * Loads PreloadAssets before anything else to show the preload screen
     * @param {soma.EventDispatcher} dispatcher 
     * @param {AssetLoadService} assetLoadService 
     */
    constructor(dispatcher, assetLoadService) {
        super();

        this.execute = function(callback, progressCallback) {
            const handleProgress = (e) => {
                progressCallback(this, e.params.progress);
            };
            
            const handleLoadComplete = () => {
                dispatcher.removeEventListener(AssetLoadServiceEvent.LOAD_PROGRESS, handleProgress);
                dispatcher.removeEventListener(AssetLoadServiceEvent.LOAD_COMPLETE, handleLoadComplete);
                callback(this);
            };

            dispatcher.addEventListener(AssetLoadServiceEvent.LOAD_PROGRESS, handleProgress);
            dispatcher.addEventListener(AssetLoadServiceEvent.LOAD_COMPLETE, handleLoadComplete);
            assetLoadService.loadGroups("PreloadAssets");
        }
    }
}
